import React, { useEffect, useState } from "react";
import Header from "components/Headers/Header";
import { get, post, put } from "utils/api";

const SecurityInsurance = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  /* =======================
     Initial Load
  ======================= */
  useEffect(() => {
    const init = async () => {
      try {
        const response = await get("/api/admin/get/security-insurance-fee");
        if (response?.success && response?.data) {
          setData({
            security_insurance_fee: response.data.security_insurance_fee || 0,
          });
        }
      } catch (error) {
        console.error("Error fetching security insurance fee:", error);
      }
    };

    init();
  }, []);

  /* =======================
     Input Change
  ======================= */
  const handleChange = (value) => {
    setData((prev) => ({
      ...prev,
      security_insurance_fee: value,
    }));
  };

  /* =======================
     Save / Update
  ======================= */
  const handleSubmit = async () => {
    if (!data.security_insurance_fee && data.security_insurance_fee !== 0) {
      alert("Security Insurance Fee is required");
      return;
    }
    const payload = {
      security_insurance_fee: Number(data.security_insurance_fee),
    };
    try {
      setLoading(true);
      const response = await post(
        "/api/admin/add/security-insurance-fee",
        payload,
      );

      if (response?.success) {
        alert(
          response.message || "Security insurance fee updated successfully",
        );
        // Refresh the data
        if (response?.data) {
          setData({
            security_insurance_fee: response.data.security_insurance_fee || 0,
          });
        }
      }
    } catch (error) {
      console.error("Error updating security insurance fee:", error);
      alert("Failed to update security insurance fee");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="container mt-4">
        <h3 className="mr-auto">Security Insurance Fee</h3>

        <div className="card p-3 mb-3">
          <div className="mb-4">
            <div className="row mt-3 align-items-end">
              <div className="col-md-10">
                <label>
                  Security Insurance Fee (Monthly){" "}
                  <i
                    title={`Security fee per day: $ ${(data.security_insurance_fee / 30).toFixed(2)}`}
                    className="fa-solid fa-circle-info"
                  ></i>{" "}
                  *
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    className="form-control"
                    min={0}
                    max={100}
                    value={data.security_insurance_fee || ""}
                    onChange={(e) => handleChange(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <button
                  className="btn"
                  style={{
                    backgroundColor: "#0474ba",
                    color: "#fff",
                  }}
                  disabled={loading}
                  onClick={() => handleSubmit()}
                >
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SecurityInsurance;
